module.exports = __webpack_public_path__ + "static/media/hofstra.4abca388.png";